import { BLangSwitcher } from "@brg/ui";
import { useMemo } from "react";
import { AppTester } from "supporting";

interface LangSwitcherProps {
    mobile?: boolean;
    currentLanguage?: string;
    onLangSelect?: (lang: string) => void;
    itemStyle?: string;
    activeBg?: string;
}

const LangSwitcher = (props: any) => {

    const mainLanguage = useMemo(() => {
        if (AppTester.isFr() || AppTester.isOnlinesDesign()) {
            return {
                label: 'FR',
                value: 'fr',
            };
        }

        return {
            label: 'RU',
            value: 'ru',
        };

    }, []);

    return (
        <BLangSwitcher
            languages={[
                mainLanguage,
                {
                    label: 'EN',
                    value: 'en',
                },
            ]}
            {...props}
        />
    )
}

export default LangSwitcher;import { BLangSwitcher } from "@brg/ui";
import { useMemo } from "react";
import { AppTester } from "supporting";

interface LangSwitcherProps {
    mobile?: boolean;
    currentLanguage?: string;
    onLangSelect?: (lang: string) => void;
    itemStyle?: string;
    activeBg?: string;
}

const LangSwitcher = (props: any) => {

    const mainLanguage = useMemo(() => {
        if (AppTester.isFr() || AppTester.isOnlinesDesign()) {
            return {
                label: 'FR',
                value: 'fr',
            };
        }

        return {
            label: 'RU',
            value: 'ru',
        };

    }, []);

    return (
        <BLangSwitcher
            languages={[
                mainLanguage,
                {
                    label: 'EN',
                    value: 'en',
                },
            ]}
            {...props}
        />
    )
}

export default LangSwitcher;